/**
 * Add days to given date (Pure, doesn't mutate given date)
 * @param date
 * @param days
 * @returns {Date}
 */
export default function addDays (date, days) {
    const dateClone = new Date(date.getTime())
    return new Date(dateClone.setDate(dateClone.getDate() + days))
}
